module.exports = "fragment SponsorFragment on User {\n  ...MinimalSponsorFragment\n  shippingAddress {\n    city\n    state\n  }\n}\n"